import { createResource } from "frappe-ui-src/resources/resources"
import { computed, reactive } from "vue"

import { userResource } from "./user"
import { visitApi } from "./vendorPortal"

const portalLoginKey = "vendor_portal_logged_in"
const portalAccessKey = "vendor_portal_access"
const portalUserKey = "vendor_portal_user"
let accessVerified = false

export function sessionUser() {
	const cookies = new URLSearchParams(document.cookie.split("; ").join("&"))
	let _sessionUser = cookies.get("user_id")
	if (_sessionUser === "Guest") {
		_sessionUser = null
	}
	return localStorage.getItem(portalUserKey) || _sessionUser
}

function hasPortalLogin() {
	return localStorage.getItem(portalLoginKey) === "1"
}

function setPortalLogin(value) {
	if (value) {
		localStorage.setItem(portalLoginKey, "1")
	} else {
		localStorage.removeItem(portalLoginKey)
		localStorage.removeItem(portalUserKey)
		accessVerified = false
	}
}

function getPortalAccess() {
	try {
		return JSON.parse(localStorage.getItem(portalAccessKey) || "{}")
	} catch {
		return {}
	}
}

function setPortalAccess({ access_level, permissions } = {}) {
	if (access_level || permissions?.length) {
		localStorage.setItem(portalAccessKey, JSON.stringify({ access_level, permissions: permissions || [] }))
	} else {
		localStorage.removeItem(portalAccessKey)
	}
}

const storedAccess = getPortalAccess()

function applyPortalAccess(data = {}) {
	setPortalAccess(data)
	session.accessLevel = data.access_level || null
	session.permissions = data.permissions || []
}

export const session = reactive({
	login: createResource({
		url: "amc_management.api.vendor_portal_api.vendor_login",
		makeParams({ email, password }) {
			return {
				usr: email,
				pwd: password,
			}
		},
		onSuccess(data) {
			if (!data?.success) {
				setPortalLogin(false)
				session.user = null
				session.hasPortalLogin = false
				throw new Error(data?.message || "Username or password incorrect")
			}

			setPortalLogin(true)
			applyPortalAccess(data)
			userResource.reload()
			session.user =
				data.user || sessionUser() || session.login.params?.usr || null
			localStorage.setItem(portalUserKey, session.user)
			accessVerified = true
			session.hasPortalLogin = true
			session.login.reset()
		},
	}),
	refreshAccess: createResource({
		url: visitApi.profile,
		onSuccess(data) {
			applyPortalAccess(data)
			accessVerified = true
		},
		onError() {
			setPortalLogin(false)
			applyPortalAccess()
			session.user = null
			session.hasPortalLogin = false
		},
	}),
	logout: createResource({
		url: "logout",
		onSuccess() {
			setPortalLogin(false)
			applyPortalAccess()
			userResource.reset()
			session.user = null
			session.hasPortalLogin = false
		},
	}),
	user: sessionUser(),
	accessLevel: storedAccess.access_level || null,
	permissions: storedAccess.permissions || [],
	hasPortalLogin: hasPortalLogin(),
	isLoggedIn: computed(() => session.hasPortalLogin && !!session.user),
	async ensureAccess() {
		if (!session.isLoggedIn || accessVerified) return
		try { await session.refreshAccess.submit() } catch { /* onError clears the local session. */ }
	},
})
